<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ title }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <div class="field-row">
      <div class="field">
        <span class="field-label">Guest house</span>
        <select class="text-box-active" formControlName="setId">
          @for(s of data.sets; track s.setId){ <option [value]="s.setId">{{ s.name }}</option> }
        </select>
      </div>
      <div class="field">
        <span class="field-label">Category</span>
        <select class="text-box-active" formControlName="category">
          <option value="ROOM">Room</option>
          <option value="HALL">Hall</option>
        </select>
      </div>
      @if(!isEdit){
      <div class="field">
        <span class="field-label">Status</span>
        <select class="text-box-active" formControlName="status">
          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
        </select>
      </div>
      }
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Room number</span><input class="text-box-active" type="number" formControlName="accommodationNumber" /></div>
      <div class="field"><span class="field-label">Short name</span><input class="text-box-active" formControlName="abbrevName" /></div>
      <div class="field"><span class="field-label">Floor</span><input class="text-box-active" type="number" formControlName="floorNumber" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Beds</span><input class="text-box-active" type="number" formControlName="bedCount" /></div>
      <div class="field"><span class="field-label">Total capacity</span><input class="text-box-active" type="number" formControlName="totalCapacity" /></div>
    </div>
    <div class="flag-row">
      <label class="flag"><input type="checkbox" formControlName="regularFlag" /> Regular bookings</label>
      <label class="flag"><input type="checkbox" formControlName="regularAutoAllocFlag" /> Regular auto-allocate</label>
      <label class="flag"><input type="checkbox" formControlName="utsavFlag" /> Utsav bookings</label>
      <label class="flag"><input type="checkbox" formControlName="utsavAutoAllocFlag" /> Utsav auto-allocate</label>
    </div>
    <div class="field-row">
      <div class="field">
        <span class="field-label">Utsav allocation type</span>
        <input class="text-box-active" formControlName="allocationType" placeholder="NONE" />
      </div>
      <div class="field">
        <span class="field-label">Utsav allocation gender</span>
        <select class="text-box-active" formControlName="allocationGender">
          <option value="NONE">None</option>
          <option value="MALE">Male</option>
          <option value="FEMALE">Female</option>
        </select>
      </div>
      <div class="field">
        <span class="field-label">Reserved for karmis</span>
        <select class="text-box-active" formControlName="karmiReserved">
          <option value="NO">No</option>
          <option value="YES">Yes</option>
        </select>
      </div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Comments</span><input class="text-box-active" formControlName="comments" /></div>
    </div>
    <p class="dialog-note">A new or changed room becomes bookable on future dates only, once their daily instances are generated.</p>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Cancel</button>
    <button type="button" class="ac-primary-btn" (click)="submit()">{{ isEdit ? 'Save' : 'Add' }}</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
